var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"slider",on:{"mousedown":_vm.handleMouseDown,"touchmove":_vm.handleChange,"touchstart":_vm.handleChange}},[_c('div',{staticClass:"slider-handle",style:({ left: _vm.pointerLeft })})])}
var staticRenderFns = []

export { render, staticRenderFns }